import { render, staticRenderFns } from "./BatchShipmentRequestConfirmed.vue?vue&type=template&id=54f76835&scoped=true"
import script from "./BatchShipmentRequestConfirmed.vue?vue&type=script&lang=js"
export * from "./BatchShipmentRequestConfirmed.vue?vue&type=script&lang=js"
import style0 from "./BatchShipmentRequestConfirmed.vue?vue&type=style&index=0&id=54f76835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f76835",
  null
  
)

export default component.exports